import './App.css';
import Acceuil from './Accueil';
import Carte from './Carte';
import Galerie from './Galerie';
import Menu from './Menu';
import { Routes, Route, useLocation} from 'react-router-dom';
//import MenuSpecial from './MenuSpecial';
import { useEffect } from 'react';

function usePageTitle() {
  const location = useLocation();
 useEffect(() => {
  
    switch (location.pathname) {
      case '/':
        document.title = 'De Bouche a Oreille - Accueil';
        break;
      case '/Menu':
        document.title = 'De Bouche a Oreille - Menu';
        break;
      case '/Carte':
        document.title = 'De Bouche a Oreille - Carte';
        break;
      case '/Galerie':
        document.title = 'De Bouche a Oreille - Galerie';
        break;
      case '/Menuspecial':
        document.title = 'De Bouche a Oreille - Menu spécial';
        break;
      default:
        document.title = 'Restaurant de Bouche a Oreille';
    }
  }, [location.pathname]);
}

function App() {
  usePageTitle();
  return (
   
    <Routes>
      
        <Route path="/" element={<Acceuil/>}></Route>
        <Route path="/Menu"  element={<Menu/>}/>
        <Route path="/Carte"  element={<Carte/>}/>
        <Route path="/Galerie" element={<Galerie/>}/>
{/* <Route path="/Menuspecial" element={<MenuSpecial/>}/>*/}
        
      </Routes>
     
    
  );
}

export default App;
